import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import {

  MyEarningData,
} from "modules/MyEarning/components";

type Props = {};

const MyEarningContainer = (props: Props) => {

  return (
    <AppLayout>

      <MyEarningData />

    </AppLayout>
  );
};

export default MyEarningContainer;
